// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.radio input[type=radio] {
  margin-left: 0px;
}

.grey {
  background: rgba(236, 236, 236, 0.9);
}

.team-actions a:not(:last-child) {
  margin-right: 8px;
}

.modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  display: none;
  overflow: hidden;
  -webkit-overflow-scrolling: touch;
  outline: 0;
}
.modal.show {
  display: block !important;
}
.modal.grey {
  background: rgba(236, 236, 236, 0.9);
}
.modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
}
.modal.fade.in {
  opacity: 1;
}
.modal.in .modal-dialog {
  transform: translate(0, 0);
}
.modal.modal-open {
  overflow-x: hidden;
  overflow-y: auto;
}
.modal .modal-dialog {
  position: relative;
  width: auto;
  margin: 10px;
}
@media (min-width: 768px) {
  .modal .modal-dialog {
    width: 600px;
    margin: 30px auto;
  }
}
.modal .modal-dialog .modal-content {
  background-clip: padding-box;
  background-color: #FFFFFF;
  border: 1px solid rgba(0, 0, 0, 0);
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  outline: 0 none;
  position: relative;
}
.modal .modal-dialog .modal-content .close {
  float: right;
  font-size: 21px;
  font-weight: bold;
  line-height: 1;
  color: #000;
  text-shadow: 0 1px 0 #fff;
  filter: alpha(opacity=20);
  opacity: 0.2;
}
.modal .modal-dialog .modal-content .close:focus-visible {
  outline: none;
}
.modal .modal-dialog .modal-content button.close {
  padding: 0;
  cursor: pointer;
  background: transparent;
  border: 0;
  appearance: none;
}
.modal .modal-dialog .modal-content .modal-body form .form-group {
  margin-bottom: 15px;
}
.modal .f-btn {
  color: #fff;
  font-size: 14px;
  border-color: #73BF38;
  background-color: #73BF38;
}
.modal .f-btn:hover {
  border-color: #4cae4c;
  background-color: #4cae4c;
}
.modal .f-btn--dngr {
  color: #fff;
  border-color: #ED5565;
  background-color: #ED5565;
}
.modal .f-btn--dngr:hover {
  border-color: #ec4758;
  background-color: #ec4758;
}
.modal .f-btn--info {
  color: #fff;
  border-color: #23c6c8;
  background-color: #23c6c8;
}
.modal .f-btn--info:hover {
  border-color: #21b9bb;
  background-color: #21b9bb;
}
.modal .f-btn--wrng {
  color: #fff;
  border-color: #f8ac59;
  background-color: #f8ac59;
}
.modal .f-btn--wrng:hover {
  border-color: #f7a54a;
  background-color: #f7a54a;
}

::ng-deep.modal-open {
  overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./src/app/components/account-emails/account-emails.component.scss"],"names":[],"mappings":"AAAA;EACC,gBAAA;AACD;;AAEA;EACC,oCAAA;AACD;;AAEA;EACC,iBAAA;AACD;;AAaA;EACC,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;EACA,aAAA;EACA,gBAAA;EACA,iCAAA;EACA,UAAA;AAVD;AAYC;EACE,yBAAA;AAVH;AAaC;EACE,oCAAA;AAXH;AAeG;EACD,mCAAA;AAbF;AAgBG;EACD,UAAA;AAdF;AAmBG;EACD,0BAAA;AAjBF;AAqBC;EACE,kBAAA;EACA,gBAAA;AAnBH;AAsBC;EACE,kBAAA;EACA,WAAA;EACA,YAAA;AApBH;AAsBG;EALF;IAMC,YAAA;IACA,iBAAA;EAnBA;AACF;AAqBG;EACD,4BAAA;EACA,yBAAA;EACA,kCAAA;EACA,kBAAA;EACA,wCAAA;EACA,eAAA;EACA,kBAAA;AAnBF;AAqBE;EACE,YAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,yBAAA;EACA,YAAA;AAnBJ;AAqBI;EACD,aAAA;AAnBH;AAuBE;EACE,UAAA;EACA,eAAA;EACA,uBAAA;EACA,SAAA;EAEA,gBAAA;AArBJ;AA4BI;EACC,mBAAA;AA1BL;AAiCC;EACE,WAAA;EACA,eAAA;EACA,qBAAA;EACA,yBAAA;AA/BH;AAiCG;EACD,qBAAA;EACA,yBAAA;AA/BF;AAkCG;EACD,WAAA;EACA,qBAAA;EACA,yBAAA;AAhCF;AAkCE;EACE,qBAAA;EACA,yBAAA;AAhCJ;AAoCG;EACD,WAAA;EACA,qBAAA;EACA,yBAAA;AAlCF;AAoCE;EACE,qBAAA;EACA,yBAAA;AAlCJ;AAsCG;EACD,WAAA;EACA,qBAAA;EACA,yBAAA;AApCF;AAsCE;EACE,qBAAA;EACA,yBAAA;AApCJ;;AA0CE;EACD,gBAAA;AAvCD","sourcesContent":[".radio input[type=\"radio\"]{\n\tmargin-left: 0px;\n}\n\n.grey{\n\tbackground: rgba(236, 236, 236, 0.9);\n}\n\n.team-actions a:not(:last-child) {\n\tmargin-right: 8px;\n}\n\n// .modal-body {\n\n// \t.form {\n\n// \t\t.form-group {\n// \t\t\tmargin-bottom: 15px;\n// \t\t}\n// \t}\n// }\n\n// Modal Design\n.modal {\n\tposition: fixed;\n\ttop: 0;\n\tright: 0;\n\tbottom: 0;\n\tleft: 0;\n\tz-index: 1050;\n\tdisplay: none;\n\toverflow: hidden;\n\t-webkit-overflow-scrolling: touch;\n\toutline: 0;\n  \n\t&.show {\n\t  display: block !important;\n\t}\n  \n\t&.grey {\n\t  background: rgba(236, 236, 236, 0.9);\n\t}\n  \n\t&.fade {\n\t  .modal-dialog {\n\t\ttransition: transform 0.3s ease-out;\n\t  }\n  \n\t  &.in {\n\t\topacity: 1;\n\t  }\n\t}\n  \n\t&.in {\n\t  .modal-dialog {\n\t\ttransform: translate(0, 0);\n\t  }\n\t}\n  \n\t&.modal-open {\n\t  overflow-x: hidden;\n\t  overflow-y: auto;\n\t}\n  \n\t.modal-dialog {\n\t  position: relative;\n\t  width: auto;\n\t  margin: 10px;\n  \n\t  @media (min-width: 768px) {\n\t\twidth: 600px;\n\t\tmargin: 30px auto;\n\t  }\n  \n\t  .modal-content {\n\t\tbackground-clip: padding-box;\n\t\tbackground-color: #FFFFFF;\n\t\tborder: 1px solid rgba(0, 0, 0, 0);\n\t\tborder-radius: 4px;\n\t\tbox-shadow: 0 1px 3px rgb(0 0 0 / 30%);\n\t\toutline: 0 none;\n\t\tposition: relative;\n  \n\t\t.close {\n\t\t  float: right;\n\t\t  font-size: 21px;\n\t\t  font-weight: bold;\n\t\t  line-height: 1;\n\t\t  color: #000;\n\t\t  text-shadow: 0 1px 0 #fff;\n\t\t  filter: alpha(opacity=20);\n\t\t  opacity: 0.2;\n  \n\t\t  &:focus-visible {\n\t\t\toutline: none;\n\t\t  }\n\t\t}\n  \n\t\tbutton.close {\n\t\t  padding: 0;\n\t\t  cursor: pointer;\n\t\t  background: transparent;\n\t\t  border: 0;\n\t\t  -webkit-appearance: none;\n\t\t  appearance: none;\n\t\t}\n\n\t\t.modal-body {\n\n\t\t\tform {\n\n\t\t\t\t.form-group {\n\t\t\t\t\tmargin-bottom: 15px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t  }\n\t}\n  \n\t.f-btn {\n\t  color: #fff;\n\t  font-size: 14px;\n\t  border-color: #73BF38;\n\t  background-color: #73BF38;\n  \n\t  &:hover {\n\t\tborder-color: #4cae4c;\n\t\tbackground-color: #4cae4c;\n\t  }\n  \n\t  &--dngr {\n\t\tcolor: #fff;\n\t\tborder-color: #ED5565;\n\t\tbackground-color: #ED5565;\n  \n\t\t&:hover {\n\t\t  border-color: #ec4758;\n\t\t  background-color: #ec4758;\n\t\t}\n\t  }\n  \n\t  &--info {\n\t\tcolor: #fff;\n\t\tborder-color: #23c6c8;\n\t\tbackground-color: #23c6c8;\n  \n\t\t&:hover {\n\t\t  border-color: #21b9bb;\n\t\t  background-color: #21b9bb;\n\t\t}\n\t  }\n  \n\t  &--wrng {\n\t\tcolor: #fff;\n\t\tborder-color: #f8ac59;\n\t\tbackground-color: #f8ac59;\n  \n\t\t&:hover {\n\t\t  border-color: #f7a54a;\n\t\t  background-color: #f7a54a;\n\t\t}\n\t  }\n\t}\n  }\n  \n  ::ng-deep.modal-open {\n\toverflow: hidden;\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
